const EU_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]);

export function shouldRegisterExperiment(name: string): boolean {
  return name !== 'ABACUS-546';
}

export function shouldRegisterConditionalExperiment(
  name: string,
  viewerCountry?: string
): boolean {
  if (
    name === 'ABACUS-546' &&
    (!viewerCountry || EU_COUNTRIES.has(viewerCountry))
  ) {
    return false;
  }

  return true;
}
